import axios from "../../utils/axios";
import { base_url, config } from "../../utils/axiosConfig";

const register = async (userData) => {
    try {
        const response = await axios.post(`${base_url}user/register`, userData);
        //console.log('API response:', response);
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        if (error.message === "You are offline.") {
            console.error("You're offline! Please check your connection.");
        } else {
            console.error("Something went wrong. Try again later.");
        }
    }
};

const login = async (userData) => {
    try {
        const response = await axios.post(`${base_url}user/login`, userData);

        if (response.data) {
            localStorage.setItem("customer", JSON.stringify(response.data));
            localStorage.setItem("token", response.data.token);
        }

        return response.data;
    } catch (error) {
        // Properly forward backend error message
        throw error.response?.data || error;
    }
};


const createOrder = async (orderDetail) => {
    try {
        const response = await axios.post(
            `${base_url}user/cart/create-order/`,
            orderDetail,
            config
        );
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        if (error.message === "You are offline.") {
            console.error("You're offline! Please check your connection.");
        } else {
            console.error("Something went wrong. Try again later.");
        }
    }
};

const updateOrderStatus = async ({ orderId, status, config }) => {
    try {
        const response = await axios.put(`${base_url}delivery/order/${orderId}/status`, { status }, config);
        return response.data;
    } catch (error) {
        if (error.message === "You are offline.") {
            console.error("You're offline! Please check your connection.");
        } else {
            console.error("Something went wrong. Try again later.");
        }
    }
};


const getUserOrders = async () => {
    try {
        const response = await axios.get(`${base_url}user/getmyorders`, config);
        //console.log('api respone:', response.data);
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        if (error.message === "You are offline.") {
            console.error("You're offline! Please check your connection.");
        } else {
            console.error("Something went wrong. Try again later.");
        }
    }
};

// Call the function
getUserOrders();

const updateUser = async (data) => {
    try {
        const response = await axios.put(
            `${base_url}user/edit-user`,
            data.data,
            data.config2,
            config
        );

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        if (error.message === "You are offline.") {
            console.error("You're offline! Please check your connection.");
        } else {
            console.error("Something went wrong. Try again later.");
        }
    }
};

const forgotPasswordToken = async (data) => {
    try {
        const response = await axios.post(
            `${base_url}user/forgot-password-token`,
            data
        );

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        if (error.message === "You are offline.") {
            console.error("You're offline! Please check your connection.");
        } else {
            console.error("Something went wrong. Try again later.");
        }
    }
};

const resetPass = async (data) => {
    try {
        const response = await axios.put(
            `${base_url}user/reset-password/${data.token}`,
            {
                password: data?.password,
            }
        );

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        if (error.message === "You are offline.") {
            console.error("You're offline! Please check your connection.");
        } else {
            console.error("Something went wrong. Try again later.");
        }
    }
};

const emptyCart = async (data) => {
    try {
        const response = await axios.delete(`${base_url}user/empty-cart`, data);

        if (response.data) {
            return response.data;
        }
    } catch (error) {
        if (error.message === "You are offline.") {
            console.error("You're offline! Please check your connection.");
        } else {
            console.error("Something went wrong. Try again later.");
        }
    }
};

export const authService = {

    register,
    login,
    createOrder,
    getUserOrders,
    updateUser,
    forgotPasswordToken,
    resetPass,
    emptyCart,
    updateOrderStatus
};